<script setup lang="ts">
import { ref, nextTick } from "vue";
import { useUserInfo } from "./hooks/useUserInfo";
import { useRouter } from "vue-router";
import GlobalDisposalDialog from "@/components/global-disposal-dialog.vue";
const { getUserInfo } = useUserInfo();
import { getDisposalNotice, getNotificationRead } from "@/utils/fetch";
getUserInfo();

// 判断处置能力弹窗状态
interface DialogData {
    showBindDialog: boolean;
    id: number;
    title: string;
    content: string;
}
const disposalDialogData = ref<DialogData>({
    showBindDialog: false,
    id: 0,
    title: "",
    content: "",
});
let res: any[] = [];
const { isNeedDialogPath } = useUserInfo();
const changeDisposalDialogVisible = async () => {
    if (isNeedDialogPath()) {
        res = await getDisposalNotice();
        showDisposalDialog();
    }
};
const showDisposalDialog = async () => {
    if (res.length > 0) {
        const dialogData = res.shift();
        if (dialogData) {
            disposalDialogData.value = {
                showBindDialog: true,
                id: dialogData.id,
                title: dialogData.title,
                content: dialogData.content,
            };
        }
    }
};
const closeDialog = async () => {
    disposalDialogData.value.showBindDialog = false;
    const params = { notificationId: disposalDialogData.value.id };
    await getNotificationRead(params);
    await nextTick();
    showDisposalDialog();
};

const router = useRouter();
router.afterEach(() => {
    changeDisposalDialogVisible();
});
</script>

<template>
    <div class="app">
        <router-view></router-view>
        <!-- 处置能力弹窗 -->
        <GlobalDisposalDialog
            v-if="disposalDialogData.showBindDialog"
            :id="disposalDialogData.id"
            :title="disposalDialogData.title"
            :content="disposalDialogData.content"
            @close="closeDialog"
        ></GlobalDisposalDialog>
    </div>
</template>

<script lang="ts" setup></script>

<style lang="scss">
@import url("@/assets/css/reset.css");
@import url("@/assets/css/global.css");

.ks-table {
    thead {
        color: #898a8c !important;
        font-weight: 400 !important;
    }

    th {
        background-color: #fafafa !important;
    }

    .ks-table__empty-text {
        line-height: 134px;
        color: #8c8c8c;
    }
}
.ks-dialog {
    .ks-dialog__header {
        border-bottom: none;
        padding-top: 24px;
        padding-bottom: 24px;
    }
    .ks-dialog__body {
        padding-top: 0;
    }
}

.ks-step__head {
    &.is-finish {
        .ks-step__icon-inner.is-status {
            color: #327dff;
        }
    }
    &.is-error {
        .ks-step__icon-inner.is-status {
            color: #fa4e3e;
        }
    }
}
.ks-button.ks-button--primary.is-disabled,
.ks-button.ks-button--primary.is-disabled:hover {
    background-color: #abcdff;
    border-color: #abcdff;
    color: #fff;
}
</style>
